import React, { Component, Fragment } from 'react';
import { Button, Form, Input, Segment } from 'semantic-ui-react';
import { checkFaculty, checkOrganizationalUnitsPrivilege, formatListForDropdownOptions } from '../util/util';
import {
    fetchEquipmentTypes,
    fetchEquipmentTypesByOrganizationalUnitId,
    fetchOrganizationalUnits, fetchPropertiesByOrganizationalUnitId,
    fetchUnitTypes
} from '../Lookups/util';
import axios from 'axios';
import { toast } from 'react-toastify';

class NewResource extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            equipmentType: null,
            quantity: '',
            unit: null,
            property: null,
            room: null,
            inventoryNumber: '',
            accountNumber: '',
            description: '',
            equipmentId: null,
            equipmentOptLock: null,

            equipmentTypeOptions: [],
            unitTypeOptions: [],
            roomOptions: [],
            propertyOptions: [],

            // For required fields
            organizationalUnitError: false,
            equipmentTypeError: false,
            unitError: false,
            quantityError: false,

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchEquipmentTypes = this.fetchEquipmentTypes.bind(this);
        this.fetchLookups = this.fetchLookups.bind(this);
        this.sendEquipmentRequest = this.sendEquipmentRequest.bind(this);
    }
    componentDidMount() {
        this.fetchLookups(this.props.activeRole, this.props.organizationalUnitId);
    }

    fetchLookups(activeRole, organizationalUnitId) {
        axios.all([this.fetchEquipmentTypes(activeRole, organizationalUnitId), fetchUnitTypes(), this.fetchAllRooms(), fetchPropertiesByOrganizationalUnitId()])
            .then(axios.spread((equipmentTypesRes, unitTypesRes, roomsRes, propertiesRes) => {
                const equipmentTypes = formatListForDropdownOptions(equipmentTypesRes.data);
                const unitTypes = formatListForDropdownOptions(unitTypesRes.data);
                // They are treated as lookups, despite they are not.
                const rooms = formatListForDropdownOptions(roomsRes.data);
                // Can't generalize with the formatListForDropdown due to its property 'property'
                const properties = propertiesRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name,
                }));
                const lookups = {
                    equipmentTypes,
                    unitTypes,
                    rooms,
                    properties
                };
                this.setState({
                    equipmentTypeOptions: equipmentTypes,
                    unitTypeOptions: unitTypes,
                    roomOptions: rooms,
                    propertyOptions: properties
                });
            }))
            .catch(err => {
                this.setState({ error: true, loading: false });
                console.log('Failed to fetch lookups data.', err);
            });
    }

    fetchEquipmentTypes(activeRole, organizationalUnitId) {
        return checkOrganizationalUnitsPrivilege(activeRole) ?
            fetchEquipmentTypes() :
            fetchEquipmentTypesByOrganizationalUnitId(organizationalUnitId);
    }

    fetchRooms() {
        return axios.get('/assets/rooms/');
    }

    fetchAllRooms() {
        return axios.get('/assets/rooms/all/');
    }

    fetchProperties() {
        return axios.get('/assets//by-organizational-unit/');
    }

    fetchAllProperties() {
        return axios.get('/assets/organizational-unit-properties/all/');
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    sendEquipmentRequest() {
        const {
            organizationalUnitId,
            equipmentType,
            quantity,
            unit,
            property,
            room,
            description,
            equipmentId,
            equipmentOptLock,
            inventoryNumber,
            accountNumber,
        } = this.state;

        if (equipmentType === null || quantity === null || quantity === ''
            || unit === null || (!this.props.property && property === null)) {
            this.setState({
                equipmentTypeError: equipmentType === null,
                unitError: unit === null,
                quantityError: quantity === null || quantity === '',
                propertyError: property === null,
            });

            toast('Nisu popunjena sva potrebna polja!');

            return;
        }

        const equipmentRequest = {
            equipmentType: { id: equipmentType },
            number: quantity,
            unitType: unit ? { id: unit } : null,
            property: { id: this.props.property ? this.props.property.id : property },
            room: { id: room },
            description,
            inventoryNumber,
            accountNumber
        };

        axios.post('/assets/equipment/', { ...equipmentRequest })
            .then(res => {

                this.props.closeForm();
                if (checkFaculty(this.props.activeRole)) {
                    this.props.fetchEquipment();
                } else {
                    this.props.fetchAllEquipment();
                }
                toast('Zahtjev uspješno poslan!');
            })
            .catch(err => {
                console.log(err);
                toast('Došlo je do greške prilikom dodavanja opreme!');
            });
    }

    render() {
        return (
            <Fragment>
                <Segment clearing secondary>
                    <Form noValidate>

                        <Form.Group widths="equal">
                            <Form.Dropdown
                                clearable
                                label="Tip"
                                placeholder="Izaberite tip"
                                value={this.state.equipmentType}
                                options={this.state.equipmentTypeOptions}
                                name="equipmentType"
                                onChange={this.handleInputChange}
                                search
                                fluid
                                selection
                                required
                                error={this.state.equipmentTypeError}
                            />

                            <Form.Field
                                control={Input}
                                label="Količina"
                                type="number"
                                name="quantity"
                                value={this.state.quantity}
                                onChange={this.handleInputChange}
                                placeholder="Unesite količinu"
                                required
                                error={this.state.quantityError}
                            />

                            <Form.Dropdown
                                clearable
                                label="Mjera"
                                placeholder="Izaberite mjeru"
                                value={this.state.unit}
                                options={this.state.unitTypeOptions}
                                name="unit"
                                onChange={this.handleInputChange}
                                search
                                fluid
                                selection
                                required
                                error={this.state.unitError}
                            />
                            <Form.Field
                                control={Input}
                                label="Konto"
                                name="accountNumber"
                                value={this.state.accountNumber}
                                onChange={this.handleInputChange}
                                placeholder="Unesite konto"
                            />
                        </Form.Group>

                        <Form.Group widths="equal">
                            <Form.Dropdown
                                clearable
                                label="Imovina"
                                placeholder="Izaberite imovinu"
                                value={this.props.property ? this.props.property.id : this.state.property}
                                options={this.state.propertyOptions}
                                name="property"
                                disabled={this.props.property}
                                onChange={this.handleInputChange}
                                search
                                fluid
                                selection
                                required
                                error={this.state.propertyError}
                            />
                            <Form.Dropdown
                                clearable
                                label="Prostorija"
                                placeholder="Izaberite prostoriju"
                                value={this.state.room}
                                options={this.state.roomOptions}
                                name="room"
                                onChange={this.handleInputChange}
                                search
                                fluid
                                selection
                            />
                            <Form.Field
                                control={Input}
                                label="Inventarni broj"
                                name="inventoryNumber"
                                value={this.state.inventoryNumber}
                                onChange={this.handleInputChange}
                                placeholder="Unesite inventarni broj"
                            />

                            <Form.Field
                                control={Input}
                                label="Opis"
                                name="description"
                                value={this.state.description}
                                onChange={this.handleInputChange}
                                placeholder="Unesite opis"
                            />
                        </Form.Group>
                        <Button
                            floated="right"
                            onClick={this.props.closeForm}
                            basic
                            color="blue"
                        >Odustani
                        </Button>
                        <Button
                            floated="right"
                            color="blue"
                            onClick={this.sendEquipmentRequest}
                        >
                           Kreiraj
                        </Button>

                    </Form>
                </Segment>
            </Fragment>
        );
    }
}

export default NewResource;



// WEBPACK FOOTER //
// ./src/views/Assets/Resources/NewResource.js